export enum MyFavoritesBlock {
  Root = 'MyFavorites',
}
